<ng-container *ngIf="contentlet$ | async as contentlet">
  <ng-container *ngIf="deviceType$ | async as deviceType">
    <ng-container *ngIf="dotcmsHost$ | async as dotcmsHost">
      <div [class]="'container-' + contentlet.identifier">
        <div
          style="position: relative"
          [id]="'image-container-' + contentlet.identifier"
          [ngClass]="{ 'tooltip-max-width': contentlet.maxWidth, 'w-100': !contentlet.maxWidth }"
          class="tooltip-image-container"
        >
          <img
            [id]="'image-' + contentlet.identifier"
            loading="lazy"
            style="width: 100%"
            [src]="getImageSrc(deviceType, contentlet) | async"
            [attr.alt]="contentlet.alternateText || contentlet.title"
          />

          <ng-container *ngFor="let product of tooltipDetails">
            <ng-container *ngIf="getDisplayStyle(deviceType, product)">
              <div
                class="product-pointers"
                [style.top]="getTopPosition(contentlet, deviceType, product)"
                [style.left]="getLeftPosition(contentlet, deviceType, product)"
                (click)="showPopup(deviceType, product.sku)"
                (keydown)="showPopup(deviceType, product.sku)"
              >
                <ng-container *ngIf="deviceType === 'desktop'">
                  <div class="product-popup" [ngClass]="'popup-' + product.position">
                    <custom-dot-cms-product-item
                      ishProductContext
                      [sku]="product.sku"
                      [configuration]="{ addToBasket: true, image: true, name: true, price: true }"
                      [layout]="'tooltip'"
                      [productElementUniqueId]="contentlet.identifier + '-product-popup-' + product.sku"
                    ></custom-dot-cms-product-item>
                  </div>
                </ng-container>
                <span class="product-pointers-point"></span>
                <span class="product-hotspot-two"></span>
                <span class="product-hotspot"></span>
              </div>
            </ng-container>
            <ng-container *ngIf="deviceType !== 'desktop'">
              <div
                class="product-popup"
                [ngClass]="contentlet.identifier + '-product-popup-' + product.sku"
                [id]="contentlet.identifier + '-product-popup-' + product.sku"
              >
                <custom-dot-cms-product-item
                  ishProductContext
                  [sku]="product.sku"
                  [configuration]="{ addToBasket: true, image: true, name: true, price: true }"
                  [layout]="'tooltip'"
                  [productElementUniqueId]="contentlet.identifier + '-product-popup-' + product.sku"
                ></custom-dot-cms-product-item>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
